import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { useCallback } from "react";
import { AI_WORKSPACE_QUERY_KEYS } from "../constants";
import { AiWorkspaceService } from "../services/aiWorkspace.service";
import { IAIWorkspaceRequest, ICreateDraftVetRequestPayload } from "../types";
import { readApiError } from "./readApiError";

const QUERY_OPTIONS = {
  queryKey: [AI_WORKSPACE_QUERY_KEYS.REQUESTS],
  skipInvalidation: false,
};

export function useCreateDraftVetRequest(
  onSuccess?: (request: IAIWorkspaceRequest) => void
) {
  const createDraftVetRequest = useCallback(
    (payload: ICreateDraftVetRequestPayload) =>
      AiWorkspaceService.createDraftVetRequest(payload)
        .then((res) => {
          ToastService.success("Draft check created");
          return res;
        })
        .catch(async (err) => {
          ToastService.error(
            await readApiError(err, "Failed to create draft check")
          );
          throw err;
        }),
    []
  );

  const { mutate: create, isLoading: isCreating } = useMutation<
    ICreateDraftVetRequestPayload,
    BackednResponse<IAIWorkspaceRequest>
  >({
    mutationFn: createDraftVetRequest,
    options: QUERY_OPTIONS,
    onSuccess: (_client, data) => {
      if (data?.data) onSuccess?.(data.data);
    },
  });

  return { create, isCreating };
}
